// extracted by mini-css-extract-plugin
module.exports = {"dashBoardSearchForm":"DashBoardPage_dashBoardSearchForm__3zSIC","header":"DashBoardPage_header__2mzFz","form":"DashBoardPage_form__1xHp3"};